export default __webpack_public_path__ + "static/745-02bb6d2ae788cfbaa7979185e271abad.gif";